import { cn } from "helpers/classNames";
import React from "react";

interface TDProps extends React.HTMLAttributes<HTMLTableSectionElement> {}

const THead: React.FC<TDProps> = (props) => (
  <thead {...props} className={cn(`bg-stone-50 ${props.className || ""}`)} />
);

export default THead;
